<!--
 * @Description: 客戶管理
 * @Author: xiawenlong
 * @Date: 2021-05-17 08:36:40
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-06-23 16:17:08
-->
<template>
  <div class="teacher-list">
    <table-list
      title="学员列表"
      :loading="loading"
      :search-form="searchForm"
      :data="customerList"
      :columns="columns(this)"
      :operates="operates(this)"
      :pager="pager"
      @search="onSearch"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>
  </div>
</template>
<script>
// 搜索框配置
const searchForm = [
  {
    label: '学员名称',
    prop: 'consumerName',
  },
  {
    label: '手机号',
    prop: 'consumerPhone',
  },
  {
    label: '消费金额',
    type: 'section',
    propLeft: 'startAmount',
    propRight: 'endAmount',
  },
]
// 表格列配置
const columns = _this => [
  {
    prop: 'consumerName',
    label: '学员名称',
  },
  {
    prop: 'consumerPhone',
    label: '手机号码',
  },
  {
    label: '启用/禁用',
    render: (h, { row }) => {
      return [
        h('el-switch', {
          props: { value: row.userStatus, activeValue: 0, inactiveValue: -1 },
          on: {
            change: async v => {
              await _this.handleOpen(v, row)
            },
          },
        }),
      ]
    },
  },
  {
    prop: 'productCount',
    label: '购买商品总量（个）',
    align: 'center',
  },
  {
    prop: 'productSumAmount',
    label: '累计下单金额（元）',
    align: 'right',
  },
  {
    prop: 'payTime',
    label: '最近一次购买时间',
  },
]
// 表格操作按钮配置
const operates = _this => [
  {
    label: '详情',
    method: _this.handleToDetail,
  },
]
import TableList from '@/components/TableList'
import { getConsumerList, consumerChangeStatus } from '@/api/course'
import to from 'await-to'
export default {
  name: 'CustomerList',
  components: {
    TableList,
  },
  data() {
    return {
      searchForm,
      columns,
      operates,
      loading: false,
      customerList: [],
      selectTeachers: [],
      queryParams: {},
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
    }
  },
  mounted() {
    this.getConsumer()
  },
  methods: {
    //设置对外开放
    async handleOpen(v, row) {
      const [, err] = await to(consumerChangeStatus({ userId: row.userId, userStatus: v }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('操作成功')
      this.getConsumer()
    },
    async getConsumer() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(getConsumerList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.customerList = res.data.list
      this.pager.total = res.data.total
    },
    // 查询按钮
    onSearch(queryParams) {
      this.pager.current = 1
      this.queryParams = queryParams
      this.getConsumer()
    },
    handleToDetail({ userId }) {
      this.$router.push(`/scenter/customer/${userId}`)
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getConsumer()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getConsumer()
    },
  },
}
</script>
<style lang="scss" scoped></style>
